import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkText?: string;
}

export default function SectionHeader({ title, subtitle, linkTo, linkText }: SectionHeaderProps) {
  if (linkTo && linkText) {
    return (
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading">{title}</h2>
          {subtitle && <p className="text-sm text-foreground-500 mt-1.5">{subtitle}</p>}
        </div>
        <Link
          to={linkTo}
          className="flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
        >
          {linkText}
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </div>
        </Link>
      </div>
    );
  }

  return (
    <div className="mb-6">
      <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading">{title}</h2>
      {subtitle && <p className="text-sm text-foreground-500 mt-1.5">{subtitle}</p>}
    </div>
  );
}